import { EmailAppointmentNotificationTemplateForm } from "../EmailAptNotifTemplateForm";

export const AddEmailAppointmentNotificationTemplate = () => {
  return <EmailAppointmentNotificationTemplateForm />;
};
